// extracted by mini-css-extract-plugin
export default {"card":"card_card__wHs6K","img":"card_img__iC+xd","title":"card_title__U95W6","subtitle":"card_subtitle__BFvhm"};